import NRReactGrid from '../../../NRReactGrid/NRReactGrid';
import { DateProvider } from '../DateProvider';
import { OverallRiskProvider } from '../OverallRiskProvider/OverallRiskProvider';
import { FilePathProvider } from '../FilePathProvider';
import { CorrelationsGridNameLinkProvider } from '../NameLinkProvider/CorrelationsGridNameLinkProvider';
import React from 'react';

const correlationsColumnsExtensions = [
  {
    columnName: 'risk',
    align: 'center',
    width: 160
  }
];

const correlationsColumns = [
  {
    title: { value: 'Report' },
    name: 'assetName'
  }
];

function NRCorrelationsGrid({ setOpen, rows, loading, handleFetchMore, pageInfo, totalCount, pageSize = 10 }) {
  return (
    <NRReactGrid
      loading={loading}
      pageSize={pageSize}
      rows={rows}
      columns={correlationsColumns}
      columnExtensions={correlationsColumnsExtensions}
      showTitle={false}
      providersArray={[
        <CorrelationsGridNameLinkProvider extraParams={{ closeModal: () => setOpen(false) }} key="nameLinkProvider" for={['assetName']} />,
        <DateProvider key="dateProvider" for={['updatedAt']} />,
        <OverallRiskProvider key="overallRiskProvider" for={['risk']} />,
        <FilePathProvider key="FilepathProvider" for={['fileName']} />
      ]}
      showIntegratedSelection={false}
      showSelectAll={false}
      statesArray={[]}
      renderersArray={[]}
      addDefaultSorting={false}
      hasCursorPagination={true}
      showIntegratedPagination={true}
      handleFetchMore={handleFetchMore}
      pageInfo={pageInfo}
      totalCount={totalCount}
    />
  );
}

export default NRCorrelationsGrid;
